<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                @add="add"
                @search="search"
                @reflash="reflash"
                @del="batchDel"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Employee_name" :label="$t('getapi[3201]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Issue_Dept_Name" :label="$t('getapi[2180]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="plan_Employee_name" :label="$t('getapi[8195]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="leader_Employee_name" :label="$t('getapi[8196]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text" size="small">{{ $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[937]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isVisibleDetail" :title="$t('getapi[34]')" width="34%" :close-on-click-modal="false">
            <el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[3201]')}}</td>
					<td>
                        <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                        <el-input
                                v-model="dataList.Employee_name"
                                type="text"
                                readonly
                                size="mini"
                                class="mcolor"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(1)"></i>
                        </el-input>
                        </routejump>
                    </td>
					<td>{{$t('getapi[2180]')}}</td>
					<td>
                        <routejump :urlNo="36" :isDialog="1" @callback="beforeRoutJump">
                        <el-input
                                v-model="dataList.Issue_Dept_Name"
                                type="text"
                                readonly
                                size="mini"
                                class="mcolor"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpopup"></i>
                        </el-input>
                        </routejump>
                    </td>
                </tr>
				<tr>
                    <td>{{$t('getapi[8195]')}}</td>
					<td>
                        <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                        <el-input
                                v-model="dataList.plan_Employee_name"
                                type="text"
                                readonly
                                size="mini"
                                class="mcolor"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(2)"></i>
                        </el-input>
                        </routejump>
                    </td>
                    <td>{{$t('getapi[8196]')}}</td>
					<td>
                        <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                        <el-input
                                v-model="dataList.leader_Employee_name"
                                type="text"
                                readonly
                                size="mini"
                                class="mcolor"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(3)"></i>
                        </el-input>
                        </routejump>
                    </td>
				</tr>
                <tr>
                    <td>{{$t('getapi[143]')}}</td>
					<td><el-input v-model="dataList.remark" type="text" size="mini" ></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisibleDetail = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="save" :loading="loading"
                           :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <serce :isVisible="isVisible" queryData="ProAreaUserRightInfo" ref="ser" @getser="serclick"></serce>
        <selector :isVisible="false" :isSplitPage=true :postUrl="'/Basic/Produce/GetAreaUserEmployeePopupList'" @callback="getemployee" ref="employee"></selector>

        <!--工作中心-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Produce/GetIssueDeptPopupList'" @callback="getpopup" ref="popup"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
        name: 'employeerelation',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false,
                isVisibleDetail: false,
                DbTbNames: '', //表名
                userData: [],
                user: "",
                dataSet: [],
                dataList: {},
                oldDataList:[],
                PageIndex: 1,
                PageSize: 100,
                SelectIndexs: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectIDData: [],
                ids: "",
                btn: {
                    del: false,
                    edit: false
                },
                employeeType:'1',
                scrollTop:0,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8194]"),this.$t("getapi[11]"));
            },
            //按钮操作权限
            authority() {
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (that.$limits.ReadOnlyRightsView('plv2', 397, 1, that.total)) {
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                //操作权限-查询级别
                var limits = that.$limits.OperationAuthorityView('plv2', 397, 1, that.total);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (limits) {
                    case -1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -2:
                        that.btn.edit = true;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
                        break;
                    case 2:
                        that.btn.edit = true;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                        break;
                    case -3:
                        that.btn.edit = true;
                        that.btn.del = true;
                        that.$refs.SetBtn.SetButtonEnable('create,del,search,refresh');
                        break;
                    case 3:
                        that.btn.edit = true;
                        that.btn.del = true;
                        that.$refs.SetBtn.SetButtonEnable('create,del,search,refresh,export');
                        break;
                    default:
                        break;
                }
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SYSUsersRelation');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.PageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.getView();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.getView();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
                that.isVisibleDetail = true
                that.dataList = {
                    num: row.num,
                    Employee_id: row.Employee_id,
                    Employee_name: row.Employee_name,
                    Issue_Dept_Code: row.Issue_Dept_Code,
                    Issue_Dept_Name: row.Issue_Dept_Name,
                    plan_Employee_id: row.plan_Employee_id,
                    plan_Employee_name: row.plan_Employee_name,
                    leader_Employee_id: row.leader_Employee_id,
                    leader_Employee_name: row.leader_Employee_name,
                    remark: row.remark
                },
                    that.oldDataList = JSON.stringify(that.dataList)
            },
            // 获取数据
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Basic/Produce/GetEmployeeRelationList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            save() {
                let that = this;
                that.loading = true;
                let parm = that.dataList
                parm.LangType = that.$processdata.getLang();
                that.$http.urlpost('/Basic/Produce/SaveEmployeeRelation', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isVisibleDetail = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].num + ',';
                }
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                that.$http.urlpost('/Basic/Produce/DeleteEmployeeRelation', parm, function (res) {
                    if(res.Success == 1){
                        that.getView();
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 删除
            del(row) {
                this.ids = row.row.num;
                this.delf();
            },
            //批量删除
            batchDel() {
                let that = this;
                that.ids = this.selectIDData.substring(0, this.selectIDData.length - 1);
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this
                that.isVisibleDetail = true;
                that.dataList = {
                    num: '',
                    Employee_id: '',
                    Employee_name: '',
                    Issue_Dept_Code: '',
                    Issue_Dept_Name: '',
                    plan_Employee_id: '',
                    plan_Employee_name: '',
                    leader_Employee_id: '',
                    leader_Employee_name: '',
                    remark: ''
                }
            },
            // 刷新
            reflash() {
                this.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Basic/Produce/GetEmployeeRelationListToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            selectemployee(type){
                let that = this;
                that.employeeType = type
                that.$refs.employee.clearInput(true);
            },
            getemployee(data){
                let that = this
                console.log(data)
                if(that.employeeType == 1){
                    that.dataList.Employee_id = data.num
                    that.dataList.Employee_name = data.name
                } else if(that.employeeType == 2){
                    that.dataList.plan_Employee_id = data.num
                    that.dataList.plan_Employee_name = data.name
                } else if(that.employeeType == 3){
                    that.dataList.leader_Employee_id = data.num
                    that.dataList.leader_Employee_name = data.name
                }
            },
            //获取工作中心
            selectpopup() {
                let that = this;
                that.$refs.popup.clearInput(true);
            },
            getpopup(data) {
                let that = this
                console.log(data)
                that.dataList.Issue_Dept_Code = data.index
                that.dataList.Issue_Dept_Name = data.Issue_Dept_Name
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldDataList != JSON.stringify(that.dataList)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isVisibleDetail = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isVisibleDetail = false
                    callback(true)
                }
            },
        }
    };
</script>

<style lang="scss" scoped>

table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}</style>

